import {hitGoogleTagManager} from "./hit_google_tag_manager";

interface EventData {
    event: PropertyButtonEventType;
    eventLabel: string;
}

export enum PropertyButtonEventType {
    TILE = "invest_tile_button",
    LIST = "property_list_price_button",
    MODAL_LIST = "property_list_price_button_modal"
}

export const gtmEventPropertyButton = (data: EventData) => {
    const gtmData = {
        event: data.event,
        event_label: data.eventLabel
    };
    hitGoogleTagManager(gtmData);
};
import {hitGoogleTagManager} from "./hit_google_tag_manager";

interface EventData {
    event: PropertyButtonEventType;
    eventLabel: string;
}

export enum PropertyButtonEventType {
    TILE = "invest_tile_button",
    LIST = "property_list_price_button",
    MODAL_LIST = "property_list_price_button_modal"
}

export const gtmEventPropertyButton = (data: EventData) => {
    const gtmData = {
        event: data.event,
        event_label: data.eventLabel
    };
    hitGoogleTagManager(gtmData);
};
